/** Versao carregada nesta aba: o `<meta name="app-version">` que o build
 *  injeta no index.html. `null` em dev e nos testes (nao ha build). */
export function getLoadedVersion(): string | null {
  const content = document.querySelector('meta[name="app-version"]')?.getAttribute("content");
  return content ? content : null;
}

/** Versao que o servidor serve agora (`version.json`, gerado no build).
 *  `null` quando nao da para saber — rede fora, 404, ou o fallback de SPA
 *  devolvendo o index.html: um erro de checagem nunca vira aviso falso. */
export async function fetchServedVersion(): Promise<string | null> {
  try {
    // `no-store` + query: o arquivo muda a cada deploy e nenhum cache
    // (navegador, CDN, proxy) pode responder por ele.
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!response.ok) return null;

    const body: unknown = await response.json();
    const version = (body as { version?: unknown } | null)?.version;
    return typeof version === "string" && version ? version : null;
  } catch {
    return null;
  }
}
